import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgErrorIconSecondary from './svgs/ErrorIconSecondary.js';
import SvgErrorIcon from './svgs/ErrorIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var ErrorIcon = (props => useIcon(SvgErrorIcon, SvgErrorIconSecondary, props));

export { ErrorIcon as default };
